import Accordion from 'accordion-js';

const accordions = document.querySelectorAll('[data-accordion]');

accordions.forEach(acc => {
  const accordion = new Accordion(acc, {
    duration: 400,
    showMultiple: false,
    openOnInit: [0],
  });
});

